import { LoadingButton } from '@mui/lab'
import { useFormikContext } from 'formik'
import React from 'react'

interface Props {
  title: string
  [otherProps: string]: any
}

const LoadingButtonForm: React.FC<Props> = ({ title, ...otherProps }) => {
  const { handleSubmit } = useFormikContext()

  const handleClick: React.MouseEventHandler<HTMLButtonElement> | undefined = () => {
    handleSubmit()
  }

  return (
    <LoadingButton fullWidth {...otherProps} onClick={handleClick}>
      {title}
    </LoadingButton>
  )
}

export default LoadingButtonForm
